import { render, staticRenderFns } from "./ObservedSensorValueTable.vue?vue&type=template&id=37cde26e&scoped=true"
import script from "./ObservedSensorValueTable.vue?vue&type=script&lang=js"
export * from "./ObservedSensorValueTable.vue?vue&type=script&lang=js"
import style0 from "./ObservedSensorValueTable.vue?vue&type=style&index=0&id=37cde26e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cde26e",
  null
  
)

export default component.exports